import { render, staticRenderFns } from "./lifestyles.vue?vue&type=template&id=6086066a&lang=html&"
import script from "./lifestyles.vue?vue&type=script&lang=js&"
export * from "./lifestyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports